module.exports = __webpack_public_path__ + "img/img_kb_type6_02.105e55c0.png";